import { NgModule } from '@angular/core';
import { environment } from 'environments/environment';
import { ENV_CONFIG } from './env';
import { AuthService } from 'app/core/auth.service';
import { AuthGuardAdmin } from 'app/core//auth.guard.admin';
import { AuthGuardProvider } from 'app/core//auth.guard.provider';
import { FirebaseModule } from './firebase/firebase.module';

@NgModule({
  imports: [
    FirebaseModule,
  ],
  providers: [
    {provide: ENV_CONFIG, useValue: environment},
    AuthService,
    AuthGuardAdmin,
    AuthGuardProvider
  ]
})

export class CoreModule { }
